// Site operates in two modes:
//   lakossági (retail)    — the default. Lives at the root, no URL prefix:
//                           "/", "/szemelyi-kolcson", "/<article-slug>", ...
//   vállalati (corporate) — everything under the /vallalati prefix:
//                           "/vallalati", "/vallalati/dualis-kepzes", ...
// Keep public/index.html's inline mode script in sync with this file.
export const MODE_CORPORATE = "vallalati";
export const MODE_RETAIL = "lakossagi";
export const DEFAULT_MODE = MODE_RETAIL;

export const CORPORATE_HOME = "/vallalati";
export const RETAIL_HOME = "/";

export const RETAIL_ROUTES = {
  jelzaloghitel: "/jelzaloghitel",
  szemelyiKolcson: "/szemelyi-kolcson",
  bankszamla: "/bankszamla",
  nyugdijmegtakaritas: "/nyugdijmegtakaritas",
  eletbiztositas: "/eletbiztositas",
};

export const CORPORATE_ROUTES = {
  dualisKepzes: "/vallalati/dualis-kepzes",
  vallalatiHitel: "/vallalati/vallalati-hitel",
  szamlaoptimalizalas: "/vallalati/szamlaoptimalizalas",
  nemzetiBajnokok: "/vallalati/nemzeti-bajnokok",
  // Ügyfeleknek kiküldhető, részletes termékleírások.
  nemzetiBajnokokReszletek: "/vallalati/nemzeti-bajnokok-reszletek",
  dimopPlusz512bReszletek: "/vallalati/dimop-plusz-5-1-2-b-reszletek",
  elmaradottTersegek: "/vallalati/elmaradott-tersegek-tamogatasa",
  finanszirozasiTerkep: "/vallalati/finanszirozasi-terkep",
  // Szakértői felület (noindex), a belső értesítő e-mail linkje mutat ide.
  kkvAdmin: "/vallalati/kkv-admin/:leadId",
};

// Old URLs → their current equivalents, so already-indexed pages, ads and
// bookmarks keep working. The same list should also exist as server-side 301
// redirects (see docs/SEO_URL_MIGRATION.md) — this client-side copy is only
// the fallback for when the server serves index.html for an old URL anyway.
export const LEGACY_REDIRECTS = {
  // Retail used to be nested under /lakossagi.
  "/lakossagi": RETAIL_HOME,
  "/lakossagi/jelzaloghitel": RETAIL_ROUTES.jelzaloghitel,
  "/lakossagi/szemelyi-kolcson": RETAIL_ROUTES.szemelyiKolcson,
  "/lakossagi/bankszamla": RETAIL_ROUTES.bankszamla,
  "/lakossagi/nyugdijmegtakaritas": RETAIL_ROUTES.nyugdijmegtakaritas,
  "/lakossagi/eletbiztositas": RETAIL_ROUTES.eletbiztositas,
  "/lakossagi-bankszamla": RETAIL_ROUTES.bankszamla,
  // Corporate pages used to sit at the root, without the /vallalati prefix.
  "/dualis-kepzes": CORPORATE_ROUTES.dualisKepzes,
  "/vallalati-hitel": CORPORATE_ROUTES.vallalatiHitel,
  "/szamlaoptimalizalas": CORPORATE_ROUTES.szamlaoptimalizalas,
  "/nemzeti-bajnokok": CORPORATE_ROUTES.nemzetiBajnokok,
  "/elmaradott-tersegek-tamogatasa": CORPORATE_ROUTES.elmaradottTersegek,
  "/penzugyi-orangyal": CORPORATE_ROUTES.finanszirozasiTerkep,
  // The KKV Finanszírozási Térkép used to live at /vallalati/penzugyi-orangyal.
  "/vallalati/penzugyi-orangyal": CORPORATE_ROUTES.finanszirozasiTerkep,
};

// Corporate pages that can't live under /vallalati — the thank-you page URL
// is what Ads/GTM conversion tracking keys on, so it stays where it is.
const CORPORATE_EXTRA_PATHS = ["/koszonjuk"];

// Neutral pages belong to neither variant — they inherit the mode the visitor
// is currently in (whichever variant they navigated from).
export const NEUTRAL_PATHS = [
  "/rolunk",
  "/impresszum",
  "/adatkezelesi-tajekoztato",
];

export function isCorporatePath(pathname) {
  return (
    pathname === CORPORATE_HOME ||
    pathname.startsWith(`${CORPORATE_HOME}/`) ||
    CORPORATE_EXTRA_PATHS.includes(pathname)
  );
}

export function isNeutralPath(pathname) {
  return NEUTRAL_PATHS.includes(pathname);
}

// Resolve the explicit mode for a given path. Everything that isn't corporate
// or neutral is lakossági. Neutral paths return null so the caller can
// substitute the visitor's current (sticky) mode instead.
export function getMode(pathname) {
  if (isCorporatePath(pathname)) return MODE_CORPORATE;
  if (isNeutralPath(pathname)) return null;
  return MODE_RETAIL;
}

// Resolve the effective mode for a path, given the visitor's current sticky
// mode (used for neutral pages). Never returns null.
export function resolveMode(pathname, stickyMode) {
  const explicit = getMode(pathname);
  if (explicit) return explicit;
  return stickyMode || DEFAULT_MODE;
}
